import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "@/App";
import "@/index.css";

/**
 * Entry point — mounts the admin SPA into ``#root``.
 *
 * We deliberately do NOT wrap in ``<React.StrictMode>`` here.
 * StrictMode double-invokes effects, which on this dashboard would
 * fire double GET requests against the cross-tenant admin endpoints
 * on every page load. Production behaviour is single-firing; we
 * match that in dev so the SPA's request log matches what the
 * founder sees in prod.
 */
ReactDOM.createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);
